import React, { useState } from "react";
import { Dropdown, Menu, Table } from "antd";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  imagesend,
  pdficon,
  pdficon3,
  // plusicon,
  refreshicon,
  pdficon5,
  searchnormal,
} from "../imagepath";
// import { onShowSizeChange, itemRender } from "../Pagination";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import {
  generateCsv,
  //   handleDownloadPdfHolidays,
  handleShowJson,
} from "../../utils/constant/constant";
// import { toast } from "react-toastify";
// import { deletePharmacy } from "../../connections/deletePharmacy";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import { getQueryList } from "../../connections/getQueryList";
import useDebounce from "../../utils/hooks";
import FilterAltIcon from "@mui/icons-material/FilterAlt";



const Quires = () => {

  // const [deleteId, setDeleteId] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [queryInput, setQueryInput] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState({});
  const [appliedFilter, setAppliedFilter] = useState({});

  const {
    user: { user },
  } = useSelector((store) => store);
  const navigate = useNavigate();
  const debouncedInputQuery = useDebounce(queryInput, 1000);

  const {
    data: queryList,
    isLoading: pharmacyLoader,
    isFetching: queryFetching,
    refetch: refetchQuery,
  } = useQuery({
    queryKey: [
      "getQueryList",
      page,
      pageSize,
      debouncedInputQuery,
      appliedFilter,
    ],
    queryFn: () =>
      getQueryList(
        user?.token,
        null,
        page,
        pageSize,
        debouncedInputQuery,
        appliedFilter
      ),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });

  const handleQueryChange = (e) => {
    e.preventDefault();
    setQueryInput(e?.target?.value);
    setPage(1);
  };

  const handleFilterChange = (key, value) => {
    setFilter((prev) => {
      const updatedFilter = { ...prev };
      if (value === null || value === "" || !value) {
        delete updatedFilter[key];
      } else {
        updatedFilter[key] = value;
      }

      return updatedFilter;
    });
  };

  const handleSubmitFilter = () => {
    setPage(1);
    setAppliedFilter(filter);
  };

  const handleResetFilter = () => {
    setPage(1);
    setFilter({});
    setAppliedFilter({});
  };

  const handleToggleFilter = () => {
    // Closing the panel clears any applied filter, same as the invoice list
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };


  const columns = [
    {
      title: "Id",
      dataIndex: "id",
    },
    {
      title: "Patient name",
      dataIndex: `query_by`,
    },
    {
      title: "title",
      dataIndex: "title",
    },

    {
      title: "status",
      dataIndex: "status",
    },


    {
      title: "",
      dataIndex: "FIELD8",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>

              {/* <Menu.Item key="view">
                <Link to={`/admin/pharmacies/${record?.id}`}>
                  <i className="fa-regular fa-eye m-r-5" /> View
                </Link>
              </Menu.Item> */}

              <Menu.Item
                key="edit"
                onClick={() =>
                  navigate("/admin/update_quires", { state: record })
                }
              >
                <i className="far fa-edit me-2" /> Edit
              </Menu.Item>

              {/*              
              <Menu.Item
                className="dropdown-item"
                to="#"
                data-bs-toggle="modal"
                data-bs-target="#delete_patient"
                key="delete"
                onClick={() => setDeleteId(record.id)}
              >
                <i className="fa fa-trash-alt m-r-5" /> Delete
              </Menu.Item> */}

            </Menu>
          }
          trigger={["click"]}
          placement="bottomRight"
        >
          <Link
            to="#"
            style={{ marginRight: 5 }}
            className="action-icon"
          // data-bs-toggle="dropdown"
          // aria-expanded="false"
          >
            <i className="fas fa-ellipsis-v" />
          </Link>
        </Dropdown>
      ),
    },
  ];

  // const handleDeleteRow = async () => {
  //   try {
  //     const data = await deletePharmacy(user?.token, deleteId);
  //     if (data.status.status === "SUCCESS") {
  //       toast.success("Pharmacy Deleted Successfully", deleteId);
  //       refetchQuery();
  //       setDeleteId(null);
  //     }
  //   } catch (error) {
  //     // toast.error(error.message);
  //     console.log(error);
  //   }
  // };

  const handlePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
    // refetchQuery();
  };

  const downloadPdf = (dataArray) => {
    // Return if no data
    if (!dataArray || dataArray.length === 0) return;

    // Initialize PDF document
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    // Define table headers with custom widths
    const headers = [
      { header: "Id", width: 20 },
      { header: "Name", width: 35 },
      { header: "DSt In No", width: 50 },
      { header: "DL No.", width: 40 },
      // { header: "Updated At", width: 40 },
    ];

    // Map data with formatting
    const data = dataArray?.map((item) => [
      item.id,
      item.name || "Empty",
      item.gstin_no || "Empty",
      item.dl_no || "Empty",
      //   item.updated_at,
    ]);

    // Add title
    doc.setFontSize(16);
    doc.setFont(undefined, "bold");
    doc.text("Query List", doc.internal.pageSize.getWidth() / 2, 15, {
      align: "center",
    });

    // Add timestamp
    doc.setFontSize(10);
    doc.setFont(undefined, "normal");
    doc.text(`Generated on: ${dayjs().format("YYYY-MM-DD HH:mm:ss")}`, 14, 22);

    // Configure table
    doc.autoTable({
      startY: 30,
      head: [headers.map((h) => h.header)],
      body: data,
      theme: "grid",
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        lineWidth: 0.5,
        lineColor: [200, 200, 200],
        fontSize: 10,
      },
      bodyStyles: {
        fontSize: 9,
        lineColor: [200, 200, 200],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "center" }, // ID
        1: { halign: "center" }, // Purchase Date
        2: { halign: "center" }, // Grand Total
        3: { halign: "center" }, // Paid
      },
      alternateRowStyles: {
        fillColor: [248, 248, 248],
      },
      margin: { top: 30, right: 14, bottom: 20, left: 14 },
      didDrawPage: (data) => {
        // Add page number at the bottom
        doc.setFontSize(10);
        doc.text(
          `Page ${data.pageNumber} of ${data.pageCount}`,
          doc.internal.pageSize.getWidth() / 2,
          doc.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
      },
    });

    // Save with formatted filename including timestamp
    const filename = `Pharmacy-List${dayjs().format("YYYYMMDD_HHmmss")}.pdf`;
    doc.save(filename);
  };


  return (
    <>
      <Header />
      <Sidebar activeClassName="quires" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}

            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Query</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Query List</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}


            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* Filter */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        {showFilter && (
                          <div className="col filter-container">
                            <div className="doctor-table-blk">
                              <h3 style={{ marginBottom: 2 }}>Filter</h3>
                            </div>
                            <div className="row mt-2">
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Title</label>
                                  <input
                                    value={filter?.title || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "title",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="title"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label>Status</label>
                                  <input
                                    value={filter?.status || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "status",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="open"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label style={{ whiteSpace: "nowrap" }}>
                                    User Type
                                  </label>
                                  <input
                                    value={filter?.query_user_type || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "query_user_type",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="Patient"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-lg-2">
                                <div className="form-group local-forms">
                                  <label style={{ whiteSpace: "nowrap" }}>
                                    Resource Type
                                  </label>
                                  <input
                                    value={filter?.query_resource_type || ""}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        "query_resource_type",
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    placeholder="Prescription"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-5 col-lg-3 mb-2">
                                <div className="d-flex align-items-center">
                                  <button
                                    id="filter-btn"
                                    onClick={handleSubmitFilter}
                                    className="btn btn-primary p-2"
                                  >
                                    Apply Filter
                                  </button>
                                  <button
                                    onClick={handleResetFilter}
                                    className="btn p-2 ms-2"
                                    style={{
                                      border: "1px solid #007A99",
                                      color: "#007A99",
                                      borderRadius: 8,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    {/* /Filter */}
                    {/* Table Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Query List</h3>
                            <div className="top-nav-search table-search-blk">
                              <span
                                style={{ width: "100%", position: "relative" }}
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  value={queryInput}
                                  onChange={handleQueryChange}
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="#" />
                                </Link>
                              </span>
                            </div>
                            <div className="doctor-search-blk">
                              <div className="add-group">

                                {/* <Link
                                  to="/admin/add_pharmacies"
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img src={plusicon} alt="#" />
                                </Link> */}

                                <Link
                                  onClick={refetchQuery}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img
                                    // onClick={refetchQuery}
                                    src={refreshicon}
                                    alt="#"
                                  />
                                </Link>
                                <Link
                                  onClick={handleToggleFilter}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <FilterAltIcon
                                    sx={{
                                      color: "#0097B2",
                                      ":hover": {
                                        color: "white",
                                      },
                                    }}
                                  />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-auto text-end float-end ms-auto download-grp">
                          {/* <Link id="download-pdf" to="#" className=" me-2"> */}
                          <img
                            className=" me-2"
                            onClick={() =>
                              downloadPdf(
                                queryList?.payload?.queries
                              )
                            }
                            src={pdficon}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                          {/* </Link> */}
                          {/* <Link
                           
                            id="download-csv"
                            className=" me-2"
                          > */}
                          <img
                            onClick={() =>
                              generateCsv(
                                queryList?.payload?.queries
                              )
                            }
                            className=" me-2"
                            src={pdficon3}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />

                          <img
                            onClick={() =>
                              handleShowJson(
                                queryList?.payload?.queries
                              )
                            }
                            width={"25px"}
                            height={"26px"}
                            src={pdficon5}
                            alt="#"
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </div>
                    {/* /Table Header */}
                    <div className="table-responsive doctor-list">
                      <Table
                        loading={pharmacyLoader || queryFetching}
                        pagination={{
                          current: page,
                          pageSize: pageSize,
                          total: queryList?.meta?.total_count,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: handlePageChange,
                        }}
                        scroll={{ x: "max-content" }}
                        columns={columns}
                        dataSource={queryList?.payload?.queries}
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  {/* <button
                    // onClick={handleDeleteRow}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button> */}
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      ;
    </>
  );
};

export default Quires;
